import React from 'react';
import './main.css';

const MainPage = () => {
  return (
    <div className='maincontent'>
        <div className='header-container'>
          <img src="logo1.png" alt="Logo" className="logo" />
          <h1 className='textcenter'>Empowering AI Innovations with Clear, Responsible Guidelines</h1>
        </div>
        
        <div className='content-container'>
          <div className='left-content'>
            <div className='textbox'>
              Welcome to AI Guidelines, your resource for trusted, responsible AI practices. This site offers comprehensive guidelines and best practices to help organizations and developers design, deploy, and manage AI in ways that align with ethical standards, transparency, and social responsibility. Explore our sections on fairness, accountability, privacy, and security to find actionable steps for building AI systems that prioritize trust and positive impact. With insights from leading experts and frameworks that evolve with the field, our mission is to empower you to navigate AI confidently and responsibly.
            </div>
          </div>
          
          <img src="AIGuidelines.jpg" alt="AI Illustration" className="image" />
        </div>
    </div>
  );
};

export default MainPage;
